import styled from 'styled-components';
import { theme } from 'styles';
import { Flex } from 'UI';

export const SFlex = styled(Flex)`
  border: solid 1px ${theme.color.grey85};
`;
